const AudienceSegmentationMessages = {
  english: {
    custom: {
      audienceSegmentationQuestion1: {
        min_value: 'Please enter your response, it must be greater than 0.'
      },
      audienceSegmentationQuestion2: {
        min_value: 'Please enter your response, it must be greater than 0.'
      },
      audienceSegmentationQuestion3: {
        min_value: 'Please enter your response, it must be greater than 0.'
      }
    }
  }
};

export default AudienceSegmentationMessages;
